import { render, staticRenderFns } from "./Questions2.vue?vue&type=template&id=01567a33"
import script from "./Questions2.vue?vue&type=script&lang=js"
export * from "./Questions2.vue?vue&type=script&lang=js"
import style0 from "./Questions2.vue?vue&type=style&index=0&id=01567a33&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports